import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startGetPTServicio } from "../../../../../context/actions/ptActions";
import { UploadSinNombre } from "../../../../../components/upload/UploadSinNombre";
import { useGetDocumentoRefcatura } from "../useGetDocumentoRefcatura";
import { CargarFileModal } from "../../../ListaRefactura/_CargarFileModal";
import { URL_PT } from "../../../../../constants/url";

export const RefacturaXml = () => {
  const { getFile } = useGetDocumentoRefcatura();

  const dispatch = useDispatch();
  const { id } = useParams();
  const { urlRefacturaXML } = useSelector(
    (state) => state.ptReducer.ptDetalle.servicioPT
  );

  if (!urlRefacturaXML)
    return (
      <div style={{ margin: 20 }}>
        <CargarFileModal
          title={`Cargar Refactura XML para el folio ${id}`}
          tooltipTitle={`Cargar refactura XML para el folio ${id}`}
          url={`${URL_PT}/UploadFilesRefactura/${id}/RefacturaXML`}
          recarga={() => dispatch(startGetPTServicio(id))}
          tituloBoton="PDF"
        />
      </div>
    );

  return (
    <>
      <div
        style={{ marginTop: 10 }}
        onClick={() => getFile(id, 3, `RefacturaXML_${id}.xml`)}
        className="rowItem"
      >
        Refactura XML
      </div>
    </>
  );
};
